"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var annotationToggleHidden = {
  event: {
    subcategory: 'filter',
    subtype: 'annotation-toggle-hidden',
    type: 'click'
  }
};
var annotationToggleVisible = {
  event: {
    subcategory: 'filter',
    subtype: 'annotation-toggle-visible',
    type: 'click'
  }
};
var filterHide = {
  event: {
    subcategory: 'filter',
    subtype: "filter-hide",
    type: 'click'
  }
};
var filterShow = {
  event: {
    subcategory: 'filter',
    subtype: "filter-show",
    type: 'click'
  }
};
var filterTime = {
  event: {
    subcategory: 'filter',
    subtype: 'filter-time',
    type: 'click'
  }
};
var filterUser = {
  event: {
    subcategory: 'filter',
    subtype: 'filter-user',
    type: 'click'
  }
};
var clearFilters = {
  event: {
    subcategory: 'filter',
    subtype: 'clear-filters',
    type: 'click'
  }
};
var backToUnresolved = {
  event: {
    subcategory: 'filter',
    subtype: 'back-to-unresolved',
    type: 'click'
  }
};
var viewUnresolved = {
  event: {
    subcategory: 'filter',
    subtype: 'view-resolved',
    type: 'click'
  }
};
var showNonGlobal = {
  event: {
    subcategory: 'filter',
    subtype: 'show-non-global',
    type: 'click'
  }
};
var showGlobal = {
  event: {
    subcategory: 'filter',
    subtype: 'show-global',
    type: 'click'
  }
};

var generalError = function generalError(environment, error) {
  return {
    event: {
      subcategory: 'general-error',
      subtype: 'error',
      type: 'render',
      error_type: error.message && error.message.replace(/\s/g, '-'),
      error_desc: 'comments-js-error',
      build: environment
    }
  };
};

var maximizeComponent = {
  event: {
    subcategory: 'navigation',
    subtype: 'maximize-component',
    type: 'click'
  }
};
var closeComponent = {
  event: {
    subcategory: 'navigation',
    subtype: 'close-component',
    type: 'click'
  }
};

var closeItemByType = function closeItemByType(itemType) {
  return {
    event: {
      subcategory: 'navigation',
      subtype: "close-".concat(itemType),
      type: 'click'
    }
  };
};

var noReviewAccess = {
  event: {
    subcategory: 'navigation',
    subtype: 'no-review-access',
    type: 'render'
  }
};
var offline = {
  event: {
    subcategory: 'navigation',
    subtype: 'offline',
    type: 'render'
  }
};
var noComments = {
  event: {
    subcategory: 'navigation',
    subtype: 'no-comments',
    type: 'render'
  }
};
var noAsset = {
  event: {
    subcategory: 'navigation',
    subtype: 'no-asset',
    type: 'render'
  }
};
var commentsRender = {
  event: {
    subcategory: 'navigation',
    subtype: 'comment',
    type: 'render'
  }
};
var commentLoad = {
  event: {
    subcategory: 'navigation',
    subtype: 'comment-load',
    type: 'render'
  }
};

var commentsFailedToLoad = function commentsFailedToLoad(status, message) {
  return {
    event: {
      subcategory: 'navigation',
      subtype: 'error',
      type: 'render',
      error_code: status,
      error_type: message,
      error_desc: 'comments-failed-to-load'
    }
  };
};

var commentsFailedToPost = function commentsFailedToPost(status, message) {
  var isReply = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    event: {
      subtype: 'error',
      type: 'render',
      error_code: status,
      error_type: message,
      error_desc: isReply ? 'reply-failed-to-post' : 'comment-failed-to-post'
    }
  };
};

var events = {
  annotationToggleVisible: annotationToggleVisible,
  annotationToggleHidden: annotationToggleHidden,
  clearFilters: clearFilters,
  filterHide: filterHide,
  filterShow: filterShow,
  filterTime: filterTime,
  filterUser: filterUser,
  backToUnresolved: backToUnresolved,
  viewUnresolved: viewUnresolved,
  showNonGlobal: showNonGlobal,
  showGlobal: showGlobal,
  generalError: generalError,
  maximizeComponent: maximizeComponent,
  closeComponent: closeComponent,
  closeItemByType: closeItemByType,
  noReviewAccess: noReviewAccess,
  offline: offline,
  noComments: noComments,
  noAsset: noAsset,
  commentsRender: commentsRender,
  commentLoad: commentLoad,
  commentsFailedToLoad: commentsFailedToLoad,
  commentsFailedToPost: commentsFailedToPost
};
var _default = events;
exports.default = _default;